import { SoftwareAppSchema } from '@/shared/seo';
import { APP_IDS, SITE_URL } from '@/shared/site';
import { COMMUNITY_LINKS, DOWNLOAD_LINKS } from '@/travo/config';
import { copyFor, LOCALES, TRAVO_BASE } from '@/travo/i18n';
import mapScreenshot from '@/travo/assets/images/home/previews/app-home-map.webp';
import checkinsScreenshot from '@/travo/assets/images/home/previews/app-daily-highlights.webp';

interface TravoAppSchemaProps {
  description: string;
  featureList: string[];
}

/** The Travo app's full entity, on Travo's home page in every locale. Screenshots are hashed asset URLs. */
const TravoAppSchema = ({ description, featureList }: TravoAppSchemaProps) => (
  <SoftwareAppSchema
    id={APP_IDS.travo}
    name="Travo"
    url={SITE_URL + TRAVO_BASE}
    description={description}
    operatingSystem="iOS, Android"
    applicationCategory="TravelApplication"
    inLanguage={LOCALES.map((locale) => copyFor(locale).htmlLang)}
    featureList={featureList}
    downloadUrl={[DOWNLOAD_LINKS.appStore, DOWNLOAD_LINKS.playStore]}
    sameAs={[COMMUNITY_LINKS.telegram, COMMUNITY_LINKS.productHunt]}
    screenshot={[mapScreenshot, checkinsScreenshot].map((src) => SITE_URL + src)}
  />
);

export default TravoAppSchema;
